module.exports = __webpack_public_path__ + "static/media/resize-circle.cbdc7baf.svg";